import React, { Component }  from "react";
import ReactDOM from "react-dom";
import WidgetSelection from './WidgetSelection.js';
import Promise from 'promise-polyfill';
if (!window.Promise) {
    window.Promise = Promise;
    console.log('ie');
  }

ReactDOM.render(<WidgetSelection />,   document.getElementById('aculistWidgetRoot'));


// WEBPACK FOOTER //
// ./src/indexmain.js